<template>
  <autocomplete
    item-value="id"
    item-text="ragione_sociale"
    :items="items"
    :loading="loading"
    :value="value"
    v-bind="$attrs"
    v-on="$listeners"/>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'AgricoltoriSelect',
    props: {
        value: { required: false }
    },
    created () {
        this.$store.dispatch('loadAgricoltori').catch(e => {
            this.$snackbar.showServerError(e)
        })
    },
    computed: {
        ...mapState({
            items: state => state.global.agricoltori,
            loading: state => state.global.loading.agricoltori
        })
    }
}
</script>
